import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router'
import { Button } from '@tutlo/ui'

export type RouterContext = { queryClient: QueryClient }

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
  notFoundComponent: () => (
    <main className="mx-auto flex min-h-dvh max-w-[480px] flex-col justify-center px-base">
      <h1 className="text-h3">Nie ma takiej strony</h1>
      <p className="text-body text-text-secondary">
        Sprawdź link z wiadomości albo zacznij od nowa.
      </p>
    </main>
  ),
  // A failed API call mid-step must not leave a blank page: reload keeps the session cookie,
  // so the lead resumes where it was (quiz step, calendar, waiting room).
  errorComponent: () => (
    <main className="mx-auto flex min-h-dvh max-w-[480px] flex-col justify-center gap-md px-base">
      <h1 className="text-h3">Coś poszło nie tak</h1>
      <p className="text-body text-text-secondary">
        Nie udało się załadować strony. Twoje odpowiedzi i rezerwacja są zapisane — spróbuj jeszcze
        raz.
      </p>
      <Button onClick={() => window.location.reload()}>Spróbuj ponownie</Button>
      <Link to="/" className="text-center text-label text-selected underline">
        Zacznij od nowa
      </Link>
    </main>
  ),
})
